import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { offline } from 'redux-offline-status'

import documentsReducer from 'src/modules/Documents/reducer'
import quotesReducer from 'src/modules/Quotes/GetQuote/reducer'
import contactReducer from 'src/modules/Contact/reducer'
import customPageReducer from 'src/modules/CustomPage/reducer'
import weatherReducer from 'src/modules/Claims/Weather/reducer'
import locationReducer from 'src/modules/Claims/Location/reducer'
import vehiclesReducer from 'src/modules/Claims/Vehicles/reducer'
import dateAndTimeReducer from 'src/modules/Claims/TimeAndDate/reducer'
import driversReducer from 'src/modules/Claims/Drivers/reducer'
import whatHappenedReducer from 'src/modules/Claims/WhatHappened/reducer'
import picturesReducer from 'src/modules/Claims/Pictures/reducer'
import vehicleAndDriverReducer from 'src/modules/Claims/OtherVehicleAndDriver/reducer'
import investigatingOfficerReducer from 'src/modules/Claims/InvestigatingOfficer/reducer'
import passengerReducer from 'src/modules/Claims/Passenger/reducer'
import witnessReducer from 'src/modules/Claims/Witness/reducer'
import noteReducer from 'src/modules/Claims/Notes/reducer'
import inventoryReducer from 'src/modules/Inventory/reducer'
import paymentReducer from 'src/modules/Payments/reducer'
import usersReducer from 'src/modules/Users/reducer'
import chatReducer from 'src/modules/Chat/reducer'
import reviewReducer from 'src/modules/Claims/Review/reducer'
import claimNumbersReducer from 'src/modules/Claims/PhoneNumbers/reducer'
import mailPinkSlipReducer from 'src/modules/Documents/MailPinkSlip/reducer'
import documentDriverReducer from 'src/modules/Documents/Driver/reducer'
import documentVehicleReducer from 'src/modules/Documents/Vehicle/reducer'
import appReducer from 'src/modules/App/reducer'
import nonPersistentAppReducer from 'src/modules/App/nonPersistentReducer'
import insurancesReducer from 'src/modules/Payments/Insurances/reducer'
import claimsReducer from 'src/modules/Claims/reducer'

export const rootReducers = {
  offline,
  documents: documentsReducer,
  quotes: quotesReducer,
  contact: contactReducer,
  customPage: customPageReducer,
  vehicles: vehiclesReducer,
  weather: weatherReducer,
  claimLocation: locationReducer,
  dateAndTime: dateAndTimeReducer,
  drivers: driversReducer,
  pictures: picturesReducer,
  whatHappened: whatHappenedReducer,
  vehicleAndDriver: vehicleAndDriverReducer,
  investigatingOfficer: investigatingOfficerReducer,
  passenger: passengerReducer,
  witness: witnessReducer,
  note: noteReducer,
  inventory: inventoryReducer,
  payment: paymentReducer,
  user: usersReducer,
  chat: chatReducer,
  reviewReducer,
  claimNumbersReducer: claimNumbersReducer,
  mailPinkSlipReducer,
  documentDriverReducer,
  documentVehicleReducer,
  appReducer,
  nonPersistentAppReducer,
  insurancesReducer,
  claims: claimsReducer
}

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  ...rootReducers
})

export default createRootReducer
